/* eslint-disable */
import CryptoJS from 'crypto-js';

class BaseCode {
  _getiv () {
    return CryptoJS.enc.Utf8.parse('GUm1nMOxoOy1UNEg');
  }
  _getmd5 (var_data) {
    var hash = CryptoJS.MD5(var_data);
    return hash;
  }
  _getmd5String (var_data) {
    var hash = CryptoJS.MD5(var_data).toString();
    return hash;
  }
  _getsha256 (var_data) {
    var hash = CryptoJS.SHA256(var_data);
    return hash;
  }

  _getuuid () {
    var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0; var v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
    return uuid;
  }
  _getsnkey () {
    var data = this._getuuid() + this._getuuid() + this._getuuid();
    var md5key = this._getmd5(data);
    var sha256key = this._getsha256(data);
    var snkey = md5key + sha256key;
    return snkey;
  }
  _getguidkey () {
    var data = this._getuuid() + this._getuuid() + this._getuuid();
    var md5key = this._getmd5(data);
    var sha256key = this._getsha256(data);
    var guidkey = sha256key + md5key;
    return guidkey;
  }
  _getrefkey (guidkey) {
    var amount = 0;
    for (var i = 0; i < guidkey.length; i++) {
      var asc = guidkey[i].charCodeAt(0);
      var reversebyte = ((asc << 4) & 0xf0) + ((asc >> 4) & 0x0f);
      amount = amount + (reversebyte % 127);
    }
    var reversestr = amount.toString();
    var b64 = btoa(this._getsha256(btoa(this._getmd5(reversestr.toString(CryptoJS.enc.Hex)))));
    var key = reversestr + b64;
    var refkey = btoa(this._getsha256(CryptoJS.enc.Utf8.parse(key)));
    return refkey;
  }
  _getfinalkey (snkey, refkey) {
    var key = snkey + refkey;
    var finalkey = btoa(this._getsha256(CryptoJS.enc.Utf8.parse(key)));
    finalkey = finalkey.substring(0, 32);
    return finalkey;
  }
}

class EncryptMsg {
  _getnowtime () {
    var today = new Date();
    var timestamp = today.getFullYear() + '/' + (today.getMonth() + 1) + '/' + today.getDate() + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
    return timestamp;
  }
  getEncryptionInfo (message) {
    var encryptMsg = this.encryptmsg(message);
    var class_basecode = new BaseCode();
    var checksum_cryptedstr = class_basecode._getmd5String(encryptMsg.cryptedstr.toString());
    var encryptInfo = {
      SN: encryptMsg.snkey,
      GUID: encryptMsg.guidkey,
      Data: encryptMsg.cryptedstr,
      CheckSum: checksum_cryptedstr,
      TimeStamp: this._getnowtime()
    };
    return encryptInfo;
  }
  encryptmsg (message) {
    try {
      var class_basecode = new BaseCode();
      var iv = class_basecode._getiv();
      var snkey = class_basecode._getsnkey();
      var guidkey = class_basecode._getguidkey();
      var refkey = class_basecode._getrefkey(guidkey);
      var finalkey = class_basecode._getfinalkey(snkey, refkey);
      var key = CryptoJS.enc.Utf8.parse(finalkey);
      var cryptedstr = CryptoJS.AES.encrypt(message, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.ZeroPadding });
      return {
        snkey: btoa(snkey),
        guidkey: btoa(guidkey),
        cryptedstr: cryptedstr.toString()
      };
    } catch (err) {
      return {
        SN: btoa(''),
        guidkey: btoa(''),
        cryptedstr: btoa('')
      };
    }
  }
}

class DecryptMsg {
  getDecryptionInfo (message) {
    var decryptdata = this.decryptmsg(message.SN, message.GUID, message.Data);
    var json_data = JSON.parse(decryptdata);
    return json_data;
  }
  checksum_data (encryptdata, checksum) {
    var class_basecode = new BaseCode();
    var md5_data = class_basecode._getmd5String(encryptdata);
    if (md5_data == checksum) {
      return true;
    }
    return false;
  }
  decryptmsg (snkey, guidkey, cryptedstr) {
    try {
      var class_basecode = new BaseCode();
      var iv = class_basecode._getiv();
      var b_snkey = atob(snkey);
      var b_guidkey = atob(guidkey);
      var b_cryptedstr = atob(cryptedstr);
      var b_refkey = class_basecode._getrefkey(b_guidkey);
      var b_finalkey = class_basecode._getfinalkey(b_snkey, b_refkey);
      var key = CryptoJS.enc.Utf8.parse(b_finalkey);
      var decrypted = CryptoJS.AES.decrypt(cryptedstr, key, { iv: iv, padding: CryptoJS.pad.ZeroPadding });
      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (err) {
      return err;
    }
  }
}

export { EncryptMsg, DecryptMsg, BaseCode };
